import arrayMove from 'array-move'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import DeleteIcon from '@material-ui/icons/Delete'
import ListSubheader from '@material-ui/core/ListSubheader'
import { IInput, InputList } from '../../../types/templates'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { Button, Grid, MenuItem, TextField, Checkbox } from '@material-ui/core'
/* import { useState } from 'react' */

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  })
)
/* const [checked, setChecked] = useState();
const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  setChecked(event.target.checked);
}; */

// Define IListInputsParams interface
interface IListInputsParams {
  setInputs: (newState: IInput[]) => void
  inputs: IInput[]
}

/**
 * Custom `SortableItem` component declaration.
 * Here the data and functionalities of each created input are showed
*/
const SortableItem = SortableElement(
  ({ input, inputs, setInputs, id }: any) => {
    return (
      <ListItem
        alignItems="flex-start"
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'space-between',
          borderStyle: 'solid',
          borderWidth: 2,
          borderRadius: 10,
          borderColor: '#0A3740',
          marginBottom: '1vh',
        }}
      >
        <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
          <h5 style={{ marginRight: '2vw' }}>{Number(id) + 1}</h5>
          <Grid item xs={6} sm={4} md={4} lg={4}>
            <TextField
              id={`inputtype${input.uid}`}
              label="Tipo de input"
              style={{ width: '90%' }}
              select
              value={input.type}
              onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                const findIndex = inputs.findIndex(
                  (i: IInput) => i.uid === input.uid
                )
                inputs[findIndex] = {
                  ...input,
                  type: event.target.value as string,
                }
                setInputs([...inputs])
              }}
            >
              {InputList.map((inputL, index: number) => (
                <MenuItem key={index} value={inputL.type}>
                  {inputL.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4} sm={3} md={3} lg={3}>
            <TextField
              id={`label${input.uid}`}
              label="Label"
              style={{ width: '90%' }}
              value={input.label || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const findIndex = inputs.findIndex(
                  (i: IInput) => i.uid === input.uid
                )
                inputs[findIndex] = {
                  ...input,
                  label: event.target.value,
                }
                setInputs([...inputs])
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3}>
            <TextField
              id={`info${input.uid}`}
              label="Descripción"
              style={{ width: '90%' }}
              value={input.info || ''}
              multiline
              rows={1}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const findIndex = inputs.findIndex(
                  (i: IInput) => i.uid === input.uid
                )
                inputs[findIndex] = {
                  ...input,
                  info: event.target.value,
                }
                setInputs([...inputs])
              }}
            />
          </Grid>
          {['select', 'multiselect'].includes(input.type) && (
            <Grid item xs={6} sm={4} md={4} lg={3}>
              <TextField
                id={`options${input.uid}`}
                label="Opciones"
                style={{ width: '90%' }}
                value={input.options || ''}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const findIndex = inputs.findIndex(
                    (i: IInput) => i.uid === input.uid
                  )
                  inputs[findIndex] = {
                    ...input,
                    options: event.target.value,
                  }
                  setInputs([...inputs])
                }}
              />
            </Grid>
          )}
          {input.type === 'list' && (
            <Grid item xs={3} sm={3} md={3} lg={3}>
              <TextField
                id={`startwith${input.uid}`}
                label="Inicia en"
                style={{ width: '90%' }}
                type="number"
                value={input.startWith || 1}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const findIndex = inputs.findIndex(
                    (i: IInput) => i.uid === input.uid
                  )
                  inputs[findIndex] = {
                    ...input,
                    startWith: Number(event.target.value),
                  }
                  setInputs([...inputs])
                }}
              />
            </Grid>
          )}
          <Grid item xs={8} sm={4} md={4} lg={3}>
            <TextField
              id={`conditional${input.uid}`}
              label="Condicional mostrar"
              style={{ width: '90%' }}
              value={input.conditional || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const findIndex = inputs.findIndex(
                  (i: IInput) => i.uid === input.uid
                )
                inputs[findIndex] = {
                  ...input,
                  conditional: event.target.value,
                }
                setInputs([...inputs])
              }}
            />
          </Grid>    
          {/* {['text', 'email', 'money', 'number',].includes(input.type) && (  
            <Grid item xs={6} sm={4} md={3} lg={3}>
              <TextField
                id={`suggestions${input.uid}`}
                label="sugerencias"
                style={{ width: '100%' }}
                value={input.suggestions || ''}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const findIndex = inputs.findIndex(
                    (i: IInput) => i.uid === input.uid
                  )
                  inputs[findIndex] = {
                    ...input,
                    suggestions: event.target.value,
                  }
                  setInputs([...inputs])
                }}
              />
            </Grid>
          )} */}
          <Grid container justifyContent={'center'} alignItems={'center'} style={{ marginTop: '1vh' }} item xs={2} sm={2} md={2} lg={2}>
            <label style={{ marginBottom: '0.5vh' }}>Campo obligatorio: </label>
            <Checkbox
              id={`obligatory${input.uid}`}
              value={input.obligatory}
              checked={input.obligatory}
              color="primary"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const findIndex = inputs.findIndex(
                  (i: IInput) => i.uid === input.uid
                )
                inputs[findIndex] = {
                  ...input,
                  obligatory: event.target.checked
                }
                setInputs([...inputs])
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={3}>
            <Button
              aria-controls="customized-menu"
              aria-haspopup="true"
              variant="contained"
              startIcon={<DeleteIcon />}
              style={{
                width: '100%',
                backgroundColor: '#DC004E',
                color: 'white',
              }}
              onClick={() => {
                const newInputs = inputs.filter(
                  (i: IInput) => i.uid !== input.uid
                )
                setInputs(newInputs)
              }}
            >
              Eliminar input
            </Button>
          </Grid>
        </Grid>
      </ListItem>
    )
  }
)

/**
 * Custom `ListInputs` component declaration.
 * This is used to map of all the inputs created
 * @return ListInputs
*/
const SortableList = SortableContainer(
  ({ inputs, setInputs }: IListInputsParams) => {
    const classes = useStyles()
    return (
      <List
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Inputs creados: {inputs.length}
          </ListSubheader>
        }
        className={classes.root}
      >
        {inputs && inputs.length > 0 ? (
          inputs.map((input: IInput, index: number) => {
            return (
              <SortableItem
                key={`item-${index}`}
                index={index}
                id={index}
                input={input}
                inputs={inputs}
                setInputs={setInputs}
              />
            )
          })
        ) : (
          <></>
        )}
      </List>
    )
  }
)

/**
 * Custom `ListInputs` component declaration.
 * @return ListInputs
*/
export default function ListInputs({ inputs, setInputs }: IListInputsParams) {
  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    setInputs(arrayMove(inputs, oldIndex, newIndex))
  }

  return (
    <SortableList
      inputs={inputs}
      setInputs={setInputs}
      onSortEnd={onSortEnd}
      distance={1}
    />
  )
}